module.exports = __webpack_public_path__ + "static/media/guesthouse-2.1.7d1719fe.jpg";